import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "../layout/Sidebar";
import AgentSidebar from "../layout/AgentSidebar";
import Swal from "sweetalert2";

export default function AttendancePage() {
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    admin_id: "",
    date1: "",
    atten_status: "P",
    permission_stime: "",
    permission_etime: "",
    permission_hour: "",
    halfday_period: "",
  });

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const today = new Date().toISOString().split("T")[0];
  const [filterDate, setFilterDate] = useState(today);
  const role = sessionStorage.getItem("role");
  const SidebarComponent = role === "agent" ? AgentSidebar : Sidebar;

  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (role === "agent") {
      fetchAgentAttendance();
    } else {
      fetchAdmins();
      fetchAttendance();
    }
  }, []);

  const fetchAdmins = async () => {
    try {
      const token = sessionStorage.getItem("access_token");
      const res = await axios.get(`${baseURL}/getAllAdmin`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdmins(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAgentAttendance = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const agentId = sessionStorage.getItem("agent_id");
      const response = await axios.get(`${baseURL}/getAgentAttendance`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          agent_id: agentId,
        },
      });
      setAttendanceRecords(response.data);
      console.log("Agent Attendance fetched successfully:", response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const fetchAttendance = async () => {
    try {
      const token = sessionStorage.getItem("access_token");
      const res = await axios.get(`${baseURL}/getAllAttendance`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAttendanceRecords(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAdd = () => {
    setIsEditMode(false);
    const today = new Date().toISOString().split("T")[0];
    setFormData({
      id: null,
      admin_id: "",
      date1: today,
      atten_status: "P",
      permission_stime: "",
      permission_etime: "",
      permission_hour: "",
      halfday_period: "",
    });
    setIsModalOpen(true);
  };
  function formatDate(dateString) {
    if (!dateString) return "";
    const parts = dateString.split("-");
    if (parts.length !== 3) return dateString;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  const handleEdit = (record) => {
    setIsEditMode(true);
    setFormData(record);
    setIsModalOpen(true);
  };

  const handleDelete = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem(item.id);
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The user has been deleted.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = sessionStorage.getItem("access_token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      if (isEditMode) {
        await axios.put(`${baseURL}/updateAttendance`, formData, config);
      } else {
        await axios.post(`${baseURL}/insertAttendance`, formData, config);
      }

      setIsModalOpen(false);
      fetchAttendance();
    } catch (err) {
      console.error(err);
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "P":
        return "Present";
      case "A":
        return "Absent";
      case "PER":
        return "Permission";
      case "H":
        return "Half Day";
      default:
        return status;
    }
  };
  const deleteItem = async (id) => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.delete(`${baseURL}/deleteAttendance`, {
        data: { id: id },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        fetchAttendance();
      } else {
        Swal.fire({
          icon: "error",
          title: "Deletion Failed",

          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const filteredRecords = attendanceRecords.filter((rec) => {
    const matchesName = rec.admin_name
      ?.toString()
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    const matchesDate = rec.date1 === filterDate;

    if (role === "agent") {
      return matchesName;
    } else {
      return matchesName && matchesDate;
    }
  });

  const currentItems = filteredRecords.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredRecords.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="bg-gray-100 flex flex-col w-full">
      <SidebarComponent />
      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">Attendance</h2>

        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0 mb-4">
            <div className="flex items-center space-x-2">
              <label>Show</label>
              <select
                className="border border-gray-300 rounded p-1"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span>entries</span>
            </div>

            <div className="flex items-center space-x-4">
              {role !== "agent" && (
                <>
                  <button
                    onClick={handleAdd}
                    className="bg-green-500 text-white px-4 py-2 rounded"
                  >
                    Add Attendance
                  </button>
                  <input
                    type="date"
                    value={filterDate}
                    onChange={(e) => setFilterDate(e.target.value)}
                    className="border border-gray-300 rounded p-1"
                  />
                </>
              )}
              <input
                type="text"
                placeholder="Search"
                className="border border-gray-300 rounded p-1"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 w-full max-w-lg">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-semibold">
                    {isEditMode ? "Update Attendance" : "Add Attendance"}
                  </h2>
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="text-gray-600 text-2xl"
                  >
                    &times;
                  </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label>Admin</label>
                    <select
                      name="admin_id"
                      value={formData.admin_id}
                      onChange={handleChange}
                      className="border p-2 w-full"
                      required
                    >
                      <option value="">Select Admin</option>
                      {admins.map((admin) => (
                        <option key={admin.id} value={admin.id}>
                          {admin.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label>Date</label>
                    <input
                      type="date"
                      name="date1"
                      value={formData.date1}
                      onChange={handleChange}
                      className="border p-2 w-full"
                      required
                    />
                  </div>

                  <div>
                    <label>Status</label>
                    <select
                      name="atten_status"
                      value={formData.atten_status}
                      onChange={handleChange}
                      className="border p-2 w-full"
                    >
                      <option value="P">Present</option>
                      <option value="A">Absent</option>
                      <option value="H">Half Day</option>
                      <option value="PER">Permission</option>
                    </select>
                  </div>

                  {(formData.atten_status === "PER" ||
                    formData.atten_status === "H") && (
                    <>
                      {formData.atten_status === "PER" && (
                        <>
                          <div>
                            <label>Permission Start Time</label>
                            <input
                              type="time"
                              name="permission_stime"
                              value={formData.permission_stime}
                              onChange={handleChange}
                              className="border p-2 w-full"
                            />
                          </div>
                          <div>
                            <label>Permission End Time</label>
                            <input
                              type="time"
                              name="permission_etime"
                              value={formData.permission_etime}
                              onChange={handleChange}
                              className="border p-2 w-full"
                            />
                          </div>
                          <div>
                            <label>Permission Hours</label>
                            <input
                              type="number"
                              name="permission_hour"
                              value={formData.permission_hour}
                              onChange={handleChange}
                              className="border p-2 w-full"
                            />
                          </div>
                        </>
                      )}

                      {formData.atten_status === "H" && (
                        <div>
                          <label>Half Day Period</label>
                          <select
                            name="halfday_period"
                            value={formData.halfday_period}
                            onChange={handleChange}
                            className="border p-2 w-full"
                            required
                          >
                            <option value="">Select Period</option>
                            <option value="AM">AM</option>
                            <option value="PM">PM</option>
                          </select>
                        </div>
                      )}
                    </>
                  )}

                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="bg-blue-500 text-white px-4 py-2 rounded"
                    >
                      {isEditMode ? "Update" : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-200">
                <tr>
                  <th className="p-2">ID</th>
                  <th className="p-2">Admin</th>
                  <th className="p-2">Date</th>
                  <th className="p-2">Status</th>
                  {role !== "agent" && <th className="p-2">Options</th>}
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((record) => (
                    <tr key={record.id} className="border-b">
                      <td className="p-2">{record.id}</td>
                      <td className="p-2">{record.admin_name}</td>
                      <td className="p-2">{formatDate(record.date1)}</td>
                      <td className="p-2">
                        {getStatusLabel(record.atten_status)}
                      </td>
                      {role !== "agent" && (
                        <td className="p-2 space-x-2">
                          <button
                            onClick={() => handleEdit(record)}
                            className="text-blue-500"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            onClick={() => handleDelete(record)}
                            className="text-red-500"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center p-4">
                      No records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="flex justify-between items-center mt-4">
            <p>
              Showing {indexOfFirstItem + 1} to{" "}
              {indexOfLastItem > filteredRecords.length
                ? filteredRecords.length
                : indexOfLastItem}{" "}
              of {filteredRecords.length} entries
            </p>
            <div className="flex space-x-2">
              <button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
                className="border px-2 py-1 rounded"
              >
                Previous
              </button>
              {[...Array(totalPages).keys()].map((num) => (
                <button
                  key={num}
                  onClick={() => handlePageChange(num + 1)}
                  className={`border px-2 py-1 rounded ${
                    currentPage === num + 1 ? "bg-blue-500 text-white" : ""
                  }`}
                >
                  {num + 1}
                </button>
              ))}
              <button
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
                className="border px-2 py-1 rounded"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
